'use strict';

import React from "react";
import RouteResultsComponent from "./components/routeResults";

export function RouteResults(props) {
    return <RouteResultsComponent 
        query={props.query}
        routes={props.routes}
        showAll={props.showAll}
        onRouteClick={props.onRouteClick}
        onShowAllClick={props.onShowAllClick} />
}
